import React from "react";
//#region components
import { EntityTopCardContent } from "components/common";
import { ReceiptUploadedBy } from "components/receipt";
//#endregion
//#region types
import { StyleEnums } from "models/enums";
import { ClassifiedReceiptTopCardProps } from "models/propTypes/receiptPropTypes";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import { TranslationKeys } from "translations";


const ClassifiedReceiptTopCardContent: React.FC<ClassifiedReceiptTopCardProps> = ({ classifiedReceipt, formRef }) => {

  const title = LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Todos.TodoCardName_ClassifiedReceiptTodo);
  const subTitle = LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Todos.TodoCardSubTypeText_ClassifiedReceiptTodo);
  const descriptionheadingThree = (
    <ReceiptUploadedBy
      personId={classifiedReceipt.createdByPersonId}
      personName={classifiedReceipt.createdByPersonName}
    />
  );

  const footerText = `${LocalizationHelperInstance.getFormattedMessage(
    TranslationKeys.Common.PurchaseDate
  )}: ${classifiedReceipt.created
    ? LocalizationHelperInstance.getFormattedDate(classifiedReceipt.created)
    : ""
  }`;

  return (
    <EntityTopCardContent
      title={title}
      subTitle={subTitle}
      descriptionheadingThree={descriptionheadingThree}
      footerText={footerText}
      statusIndicatorDisplayType={StyleEnums.DisplayType.Info}
    />
  );
};

export default ClassifiedReceiptTopCardContent;
